import { render, staticRenderFns } from "./AdDetailsAnimatedIcon.vue?vue&type=template&id=3c525dfd&scoped=true"
import script from "./AdDetailsAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./AdDetailsAnimatedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c525dfd",
  null
  
)

export default component.exports